/**
 * Returns whether a mouse click event has been triggered by the primary mouse key (typically left one), without
 * using any modifier such as shift, alt, ctrl, or meta.
 *
 * @param e             a mouse event
 * @returns {boolean}
 */
export const isPrimaryMouseButtonWithoutModifier = (e: MouseEvent | React.MouseEvent): boolean => {
  return !(e.button !== 0 || e.shiftKey || e.ctrlKey || e.altKey || e.metaKey);
};

/**
 * Returns whether a mouse click was fired because the user pressed a keyboard button that issues a synthetic mouse
 * click (such as the Enter key or sometimes, e.g. for buttons, the Space key) or because the user really clicked with
 * a mouse-like device.
 */
export const isSyntheticClick = (e: MouseEvent | React.MouseEvent): boolean => e.detail === 0;
